"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FixedCover = /*#__PURE__*/function () {
  function FixedCover(elementId, staticCover) {
    var _this = this;
    _classCallCheck(this, FixedCover);
    this.staticCover = staticCover ? $('#' + staticCover) : $('section.cover');
    this.fixedCover = $('#' + elementId);
    this.resizeTimeout;
    this.windowScrollTop;
    this.window = $(window);
    this.windowResize = $(window).width();
    this.bgVerticalPosition = this.fixedCover.data('imagePositionHorizontal') ? this.fixedCover.data('imagePositionHorizontal') : 50;
    this.initialData();
    this.window.resize(function () {
      if (_this.resizeTimeout) {
        clearTimeout(_this.resizeTimeout);
      }
      _this.resizeTimeout = setTimeout(function () {
        if (_this.window.width() != _this.windowResize) {
          _this.initialData();
          _this.setFixedCoverPosition();
        }
      }, 300);
    });
    this.window.scroll(function () {
      _this.setFixedCoverPosition();
    });
    this.getDataFromCover();
    this.setFixedCoverPosition();
  }
  _createClass(FixedCover, [{
    key: "initialData",
    value: function initialData() {
      this.navbarHeight = $('header').outerHeight(true);
      this.staticCoverHeight = this.staticCover.outerHeight(true);
      this.fixedCoverPositionFromTop = this.staticCoverHeight + this.staticCover.offset().top - this.navbarHeight;
    }
  }, {
    key: "getDataFromCover",
    value: function getDataFromCover() {
      var titleStaticCover = $('.page-title > strong', this.staticCover).text();
      var imageStaticCover = this.staticCover.css('background-image');
      var titleFixedCover = $('div.title', this.fixedCover);
      titleFixedCover.text(titleStaticCover);
      this.fixedCover.css({
        'background-image': imageStaticCover,
        'backgroundPosition': '50%' + this.bgVerticalPosition + '%'
      });
    }
  }, {
    key: "setFixedCoverPosition",
    value: function setFixedCoverPosition() {
      this.windowScrollTop = this.window.scrollTop();
      if (this.windowScrollTop > this.fixedCoverPositionFromTop) {
        this.fixedCover.addClass('active');
      } else {
        this.fixedCover.removeClass('active');
      }
    }
  }]);
  return FixedCover;
}();